<script>
    import _ from "lodash";
    import Diagnosis from "../Diagnosis";

    export default {
        data() {
            return {
                display: Diagnosis.data().muscleLevel
            }
        },
        methods: {
            find(dataCoeff) {
                let display = Diagnosis.data().muscleLevel;
                return _.find(display, function (d) {
                    return d.is(dataCoeff);
                });
            },
            variant(dataCoeff) {
                return this.find(dataCoeff).variant;
            }
        }
    }
</script>